import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import useNavigateToScripts from "hooks/navigation/useNavigateToScripts";
import { memo } from "react";

function BtnDelete() {
  const navigateToScripts = useNavigateToScripts();

  return (
    <IconButton
      onClick={() => navigateToScripts()}
      title="Close"
      sx={{ ml: "auto" }}
    >
      <CloseIcon />
    </IconButton>
  );
}

export default memo(BtnDelete);
